<div class="loader">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>